<script lang="ts">
  // Abschnitt „Verbrauch" im Baum des Bereichs Claude: die Balken.
  // Zugeklappt steht die Kurzform im Kopf (baum.svelte.ts, verbrauchLage).
  //
  // Von Hand kleiner gezogen (fest), zeigt er sich in einer ersten Stufe
  // kompakt -- je Fenster eine Zeile, „wieder voll" im Tooltip (Tim
  // 16.10.2026: „Wenn das hier kleiner gezogen wird, kann dann in erster
  // Stufe der Inhalt kompakter werden? Nur hier macht das Sinn"). Erst wenn
  // auch das nicht passt, greift „⋯ weitere" (GanzeZeilen). Gemessen wird
  // der Platz der Fläche gegen die volle Höhe, die die volle Form zuletzt
  // hatte -- in der kompakten wird sie nicht neu gemessen, sonst kippte es
  // hin und her.
  import { t } from "../i18n.svelte";
  import { getClaude } from "../claude-summary.svelte";
  import Verbrauch from "./Verbrauch.svelte";
  import { reserveAnteil, tageslimitJetzt } from "./tageslimit.svelte";

  let { fest = false }: { fest?: boolean } = $props();

  let jetzt = $state(new Date());
  $effect(() => {
    const iv = setInterval(() => (jetzt = new Date()), 60_000);
    return () => clearInterval(iv);
  });
  const antwort = $derived(getClaude());

  let wurzel = $state<HTMLDivElement | undefined>(undefined);
  let platz = $state(Infinity);
  let vollHoehe = $state(0);
  const kompakt = $derived(fest && vollHoehe > 0 && platz < vollHoehe - 1);

  $effect(() => {
    const w = wurzel;
    const roll = w?.closest<HTMLElement>(".roll");
    if (!w || !roll) return;
    const ro = new ResizeObserver(() => {
      platz = roll.clientHeight;
      if (!kompakt) vollHoehe = w.offsetHeight;
    });
    ro.observe(roll);
    ro.observe(w);
    return () => ro.disconnect();
  });
</script>

<div class="grid gap-2 px-3 {kompakt ? 'pt-0.5 pb-1.5' : 'pt-1 pb-3'}" bind:this={wurzel}>
  {#if antwort && !antwort.verbunden}
    <p class="text-danger t-meta" data-zeile>{t("claude.bruecke_weg", "Dienst homelab-claude antwortet nicht")}</p>
  {/if}
  <Verbrauch verbrauch={antwort?.stand.verbrauch} {jetzt} {kompakt} tl={tageslimitJetzt(antwort?.stand.verbrauch, jetzt)} reserve={reserveAnteil()} />
</div>
